import { createSlice, createSelector } from 'redux-starter-kit'
import { loadState } from './localStorage'
import {
  getUserLanguage,
  getCurrencyFromCountry,
} from '../locale/localizationHelper'
import { isSSR } from 'js/isSSR'
import { languages, language as allLanguages } from '../locale'
import history from '../historyObject'
import { getUserCountry } from '../auth'
import { set, get } from 'js-cookie'
import { languageCookieKey } from 'lifesum-ssr/server/shared'
const defaultState = {
  language: null,
  currency: null,
  country: null,
}

const previousState = loadState() || {}

let userLanguage
if (!isSSR) {
  const storedLanguage = get(languageCookieKey)
  userLanguage = getUserLanguage(storedLanguage)
  set(languageCookieKey, userLanguage)
}

const slice = createSlice({
  slice: 'locale',
  initialState: {
    ...defaultState,
    ...previousState.locale,
    ...(!isSSR && { language: userLanguage }),
  },
  reducers: {
    setLanguage(state, { payload: language }) {
      set(languageCookieKey, language)
      state.language = language
    },
    setCurrency(state, { payload: currency }) {
      state.currency = currency
    },
    setCountry(state, { payload: country }) {
      state.country = country
    },
  },
})

export const { reducer } = slice
export const { setCountry, setCurrency } = slice.actions

export const detectInitialLocale = () => (dispatch, getState) =>
  new Promise(resolve => {
    const {
      locale: { country, currency, language },
    } = getState()
    if (!country) {
      getUserCountry().then(country => {
        dispatch(setCountry(country))

        if (!currency) {
          dispatch(setCurrency(getCurrencyFromCountry(country)))
        }
      })
    }

    if (!currency && country) {
      dispatch(setCurrency(getCurrencyFromCountry(country)))
    }

    const pathname = document.location.pathname

    // Add language slugs to url
    if (
      language !== allLanguages.ENGLISH &&
      (pathname === '/' || pathname === '')
    ) {
      history.replace('/' + language + '/')
    }

    // Remove /en/ from URL
    if (
      (pathname.length === 3 && pathname.toLowerCase().slice(0, 3) === '/en') ||
      pathname.toLowerCase().slice(0, 4) === '/en/'
    ) {
      history.replace(pathname.slice(3))
    }

    resolve()
  })

/** Set the language of the page
 * @param newLanguage {String} The new language
 * @param redirect {Boolean} Should the user be redirected to the start page after language switch?
 */
export const setLanguage = (newLanguage, redirect = true) => dispatch =>
  new Promise((resolve, reject) => {
    if (!languages.includes(newLanguage)) reject()

    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', newLanguage)
    }

    if (typeof window !== 'undefined') {
      // Expose language to Google Optimize
      window.currentSiteLanguage = newLanguage
    }

    if (redirect) {
      history.push(
        newLanguage === allLanguages.ENGLISH ? '/' : `/${newLanguage}`
      )
    }

    dispatch(slice.actions.setLanguage(newLanguage))
    resolve()
  })

export const selectLanguage = createSelector(
  ['locale.language'],
  language => language
)

export const selectCurrency = createSelector(
  ['locale.currency'],
  currency => currency
)

export const selectCountry = createSelector(
  ['locale.country'],
  country => country
)
